import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Vibrate: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'm2 8 2 2-2 2 2 2-2 2' }],
    ['path', { d: 'm22 8-2 2 2 2-2 2 2 2' }],
    ['rect', { x: '8', y: '5', width: '8', height: '14', rx: '1' }],
  ],
];

export default Vibrate;
